import './App.css';
import Navbar from '../components/Navbar';

function App() {
  return (
    <div className="App bg-custom">
      <header>
        <Navbar />
      </header>
    </div>
  );
}

export default App;
